import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@material-ui/core"
import Autorizados from "src/views/viewAdministrador/residente/DetalleUsuario/listaAutorizar"
import { useSelector } from "react-redux"
import useStyles from "src/views/viewAdministrador/residente/useStyles"
import Page from "src/components/Page"
import { useSnackbar } from "notistack"
import TgSearch from "src/components/Buttons/TgSearch"
import {
  LoadingData,
  NoInfo,
  StyledCell,
  StyledRow,
} from "src/components/Common"
import { Security } from "@material-ui/icons"
import { getUsuarios } from "../familia/services/firestore"

const Aprobadores = () => {
  const classes = useStyles()
  const { t: tGlobal } = useTranslation("global")
  const { t: tResidents } = useTranslation("residents")
  const conjunto = useSelector(state => state.complex.complex)
  const [usuarios, setUsuarios] = useState([])
  const [filteredUsers, setFilteredUser] = useState([])
  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [searched, setSearched] = useState("")
  const columns = [
    { id: "nombre", label: "Nombre" },
    { id: "apellido", label: "Apellido" },
    { id: "cedula", label: "Cédula" },
    { id: "actions", label: "Acciones" },
  ]

  useEffect(() => {
    setLoading(true)
    const unsub = getUsuarios(conjunto.id, {
      next: res => {
        const items = res.docs.map(snap => ({ id: snap.id, ...snap.data() }))
        setUsuarios(items)
        setFilteredUser(items)
        setLoading(false)
      },
      error: () => {
        enqueueSnackbar(
          "Error al obtener los registros de familiares, ¡Inténtelo de nuevo más tarde!",
          { variant: "error" }
        )
        setLoading(false)
      },
    })
    return unsub
  }, [conjunto.id])

  const requestSearch = searchedVal => {
    setLoading(true)
    const lowerVal = searchedVal.toLowerCase()
    const filteredRows = usuarios.filter(
      row =>
        String(row.Nombre || "")
          .toLowerCase()
          .includes(lowerVal) ||
        String(row.Apellido || "")
          .toLowerCase()
          .includes(lowerVal) ||
        String(row.fullName || "")
          .toLowerCase()
          .includes(lowerVal) ||
        String(row.Cedula || "")
          .toLowerCase()
          .includes(lowerVal)
    )
    setFilteredUser(filteredRows)
    setPage(0)
    setLoading(false)
  }

  const cancelSearch = () => {
    setSearched("")
    setFilteredUser(usuarios)
    setPage(0)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }

  return (
    <Page title="Aprobadores" className={classes.root}>
      <Typography variant="h3" align="center" className="mb-2">
        <Security className="me-2" />
        Lista de Aprobadores por Residente
      </Typography>
      <br />
      <TgSearch
        placeholder="Buscar"
        value={searched}
        onChange={searchVal => requestSearch(searchVal)}
        onCancelSearch={cancelSearch}
      />
      {loading ? (
        <Box display="flex" justifyContent="center" my={5}>
          <LoadingData />
        </Box>
      ) : (
        <>
          <TableContainer component={Paper}>
            <Table
              className={classes.table}
              size="small"
              aria-label="customized table"
            >
              <TableHead>
                <TableRow>
                  {columns.map(column => (
                    <StyledCell align="center" key={column.id}>
                      {column.label}
                    </StyledCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredUsers.length > 0 ? (
                  filteredUsers
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((user, ind) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <StyledRow hover tabIndex={-1} key={ind}>
                        <StyledCell align="center">{user?.Nombre}</StyledCell>
                        <StyledCell align="center">
                          {user?.Apellido || " - "}
                        </StyledCell>
                        <StyledCell align="center">{user?.Cedula}</StyledCell>
                        <StyledCell align="center">
                          <Autorizados
                            idUser={user?.id}
                            authorized={user?.Aprobadores}
                            tGlobal={tGlobal}
                            tResidents={tResidents}
                            fullWidth={false}
                          />
                        </StyledCell>
                      </StyledRow>
                    ))
                ) : (
                  <StyledRow>
                    <StyledCell align="center" colSpan={columns.length}>
                      <NoInfo />
                    </StyledCell>
                  </StyledRow>
                )}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={filteredUsers.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>{" "}
        </>
      )}
    </Page>
  )
}

export default Aprobadores
